import React from "react";

import { Link, NavLink, useParams } from "react-router-dom";

import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";

import CallUsNow from "../common/CallUsNow";
import logo from "../../assets/footer/equity black.png";
import help_center from "../../assets/icons/help_center.svg";
import {
  decryptPayload,
  findAllowedPrefixData,
  getObjLength,
} from "../helpers/utils";

const UserAdminNavBar = ({ hideLoginURL = false }) => {
  const is_scrp_hp = localStorage.getItem("scrp_hp");
  let countyCode = decryptPayload(localStorage.getItem("county-code"));
  const { county_name, prefix } = useParams();
  // Filter out the prefix from ALLOWED_PREFIXES and allow to enter if found, otherwise redirect
  const allowedPrefixObj = findAllowedPrefixData(county_name || prefix);

  return (
    <>
      <Navbar
        className={`bg-white py-3 ${
          (localStorage.getItem("preference") === null ||
            localStorage.getItem("preference").length === 0) &&
          "top_40"
        }`}
        id="adminHeader"
      >
        <Container fluid className="px-20">
          <Navbar.Brand className="signup_logo">
            <NavLink
              to={
                is_scrp_hp
                  ? `/county-recorder/${countyCode}`
                  : getObjLength(allowedPrefixObj)
                  ? `/${allowedPrefixObj?.prefix}`
                  : "/"
              }
            >
              <img src={logo} alt="logo" className="logo-custom-width" />
            </NavLink>
          </Navbar.Brand>
          <Navbar.Collapse className="justify-content-end">
            <div className="supportContact d-flex align-items-center">
              {!hideLoginURL && (
                <NavLink
                  className="text-blue text-decoration-none px-3"
                  to={`${
                    getObjLength(allowedPrefixObj)
                      ? `/${allowedPrefixObj?.prefix}/agent-`
                      : "/"
                  }login`}
                >
                  Login
                </NavLink>
              )}
              <img
                src={help_center}
                alt="help_center"
                className="me-1 d-none d-sm-block"
              />
              <span className="me-1 d-none d-sm-block">Having trouble?</span>
              <CallUsNow
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                renderText={
                  <Link className="text-blue text-decoration-none" to="">
                    Contact support
                  </Link>
                }
              />
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default UserAdminNavBar;
